<template>
  <div class="container">
    <app-loader v-if="loading" text="Verifying your payment" />

    <div v-else-if="error">
      <strong>Error:</strong> {{ error }}
    </div>

    <div v-else>
      <div class="thank-you-card">
        <div class="icon">✔</div>
        <h2>Thank you for your purchase!</h2>
        <p>Your transaction was successful.</p>

        <div class="details">
          <p><strong>Invoice Number:</strong> {{ invoiceNumber }}</p>
          <p><strong>Date:</strong> {{ new Date().toLocaleDateString() }}</p>
        </div>

        <a href="/user-dashboard/jobs" class="btn">Return to Dashboard</a>
      </div>
    </div>
  </div>
</template>

<script>
import confetti from 'canvas-confetti';
import AppLoader from "@/components/AppLoader.vue";

export default {
  components: { AppLoader },
  data() {
    return {
      invoiceNumber: this.$route.query.invoiceNumber || '',
      session: null,
      error: null,
      loading: true,
    };
  },
  async mounted() {
    const sessionId = this.$route.query.session_id;
    if (!sessionId) {
      this.error = "No session_id in URL.";
      this.loading = false;
      return;
    }

    try {
      const response = await this.$store.dispatch("orderSaveSession", {
        session_id: sessionId,
      });

      this.session = response.session;

      // One payment activity per order (multiple orders when the cart had multiple products)
      const sessions = response.sessions || (response.session ? [response.session] : []);
      for (const session of sessions) {
        await this.$store.dispatch("sentMailOrder", {
          orderId: session.order,
          userId: session.userId,
        });
      }

      // Trigger confetti after successful payment
      setTimeout(() => {
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 },
        });
      }, 500);

    } catch (err) {
      console.error("Vue error:", err);
      this.error = err.response?.data?.error || err.message;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.container {
  min-height: 100vh;
  background: linear-gradient(to bottom, #f0fdf4, #ffffff);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  font-family: 'Segoe UI', sans-serif;
}

.thank-you-card {
  background: #ffffff;
  padding: 40px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
}

.icon {
  font-size: 48px;
  color: green;
  margin-bottom: 20px;
  animation: pop 0.6s ease-out;
}

@keyframes pop {
  0% { transform: scale(0); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

h2 {
  font-size: 28px;
  margin-bottom: 10px;
  color: #1f2937;
}

p {
  font-size: 16px;
  color: #4b5563;
}

.details {
  margin: 20px 0;
  text-align: left;
  font-size: 14px;
  color: #374151;
}

.btn {
  background-color: green;
  color: white;
  padding: 10px 24px;
  font-weight: bold;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.3s;
  display: inline-block;
  margin-top: 10px;
}

.btn:hover {
  background-color: darkgreen;
}
</style>
